import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import AccountPayableActions from '../../../../reducers/modules/report/account-payable/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/account-payable'

export default class AccountPayableMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(AccountPayableActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      AccountPayableMiddleware.showOne(dispatch, params);
      dispatch(AccountPayableActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(AccountPayableActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(AccountPayableActions.process());
          AccountPayableMiddleware.showlist(dispatch, params);
        };
  }
  static showExcel(params){
    return (dispatch) => {
        dispatch(AccountPayableActions.process());
        AccountPayableMiddleware.beforeShowExcel(dispatch, params);
      };
}

  static beforeShowExcel(dispatch, params) {
   
//     axios.post(url+'/excel',
//     params,
//     { responseType: 'blob' }
// ).then(function (response) {
//     let fileName = response.headers["content-disposition"].split("filename=")[1];
//     if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
//         window.navigator.msSaveOrOpenBlob(new Blob([response.data],
//                 { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
//             ),
//             fileName
//         );
//     } else {
//         const url = window.URL.createObjectURL(new Blob([response.data],
//             { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download',
//             response.headers["content-disposition"].split("filename=")[1]);
//         document.body.appendChild(link);
//         link.click();
//     }
//     }
// );
    
    // axios({
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`,
    //   },
    //   url: url + "/excel/",
    //   responseType: "blob",
    // })
    //   .then((response) => {
    //     if (response && response.status === 200 && response.data) {
    //       dispatch(AccountPayableActions.print(response.data.result));
    //     }
    //   })
    //   .catch((error) => {
    //     AccountPayableMiddleware.alertHendler(dispatch, error);
    //   });
  } 
  static listing(params){
    return (dispatch) => {
        dispatch(AccountPayableActions.process());
        AccountPayableMiddleware.showlisting(dispatch, params);
      };
}
  static reset(){
    return (dispatch) => {
        dispatch(AccountPayableActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(AccountPayableActions.view());
        AccountPayableMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(AccountPayableActions.submit());
        AccountPayableMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(AccountPayableActions.submit());
        AccountPayableMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(AccountPayableActions.delete());
        AccountPayableMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      AccountPayableMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-account-payable' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(AccountPayableActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        AccountPayableMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(AccountPayableActions.list(response.data.result));
          }
        })
        .catch((error) => {
          AccountPayableMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(AccountPayableActions.list(response.data.result));
        }
      })
      .catch((error) => {
        AccountPayableMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AccountPayableActions.view(response.data.result));
        }
      })
      .catch((error) => {
        AccountPayableMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(AccountPayableActions.process(),AccountPayableMiddleware.showlist(dispatch, params));
          AccountPayableMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        AccountPayableMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AccountPayableActions.process(),AccountPayableMiddleware.showlist(dispatch,search));
          dispatch(AccountPayableActions.success());
          AccountPayableMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        AccountPayableMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${AccountPayableMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(AccountPayableActions.process(),AccountPayableActions.showlist(dispatch,search));
          // dispatch(AccountPayableActions.success());
          // AccountPayableMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        AccountPayableMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(AccountPayableActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(AccountPayableActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
